import { Option } from '@beeline/design-system-react/extracted-styles';

import { EmployeePermission } from 'src/api/permissions';
import { BookingObjectType } from 'src/components/BookingObjectTypeSelect/types';
import { labelsByRoomType } from 'src/consts';
import { RoomType } from 'src/types';

export const labelsByBookingObjectType: Record<BookingObjectType, string> = {
  [BookingObjectType.Desk]: 'Рабочее место',
  [BookingObjectType.MeetingRoom]: labelsByRoomType[RoomType.Meeting],
  [BookingObjectType.FocusRoom]: labelsByRoomType[RoomType.Focus],
  [BookingObjectType.PhoneRoom]: labelsByRoomType[RoomType.Phone],
  [BookingObjectType.Parking]: 'Парковочное место',
};

export const labelsByEmployeePermission: Record<EmployeePermission, string> = {
  [EmployeePermission.BookForOthers]: 'Бронировать на других',
  [EmployeePermission.BookDesks]: 'Бронировать рабочие места',
  [EmployeePermission.BookRooms]: 'Бронировать комнаты',
  [EmployeePermission.BookParkingPlaces]: 'Бронировать парковочные места',
  [EmployeePermission.EditPlans]: 'Редактировать планы',
  [EmployeePermission.ViewBookedObjects]: 'Просматривать бронирования',
  [EmployeePermission.ViewFeedbacks]: 'Просматривать обратную связь',
  [EmployeePermission.SystemAdmin]: 'Выдавать права',
  [EmployeePermission.QA]: 'QA',
};

export const defaultRoomSeatCountByRoomType: Record<RoomType, number> = {
  [RoomType.Focus]: 2,
  [RoomType.Meeting]: 5,
  [RoomType.Phone]: 1,
};

export const deskRatio = 1.5;
export const roomRatio = 1;
export const parkingRatio = 1.33;

const defaultDeskWidth = 16;
const defaultDeskHeight = defaultDeskWidth * deskRatio;

const defaultRoomWidth = 32;
const defaultRoomHeight = defaultRoomWidth * roomRatio;

const defaultParkingWidth = 32;
const defaultParkingHeight = defaultParkingWidth * parkingRatio;

const defaultFontSize = 8;

const defaultDeskSize: [number, number, number] = [
  defaultDeskWidth,
  defaultDeskHeight,
  defaultFontSize,
];
const defaultRoomSize: [number, number, number] = [
  defaultRoomWidth,
  defaultRoomHeight,
  defaultFontSize,
];
const defaultParkingSize: [number, number, number] = [
  defaultParkingWidth,
  defaultParkingHeight,
  defaultFontSize,
];

export const defaultSizesByBookingObjectType: Record<
  BookingObjectType,
  [number, number, number]
> = {
  [BookingObjectType.Desk]: defaultDeskSize,
  [BookingObjectType.MeetingRoom]: defaultRoomSize,
  [BookingObjectType.FocusRoom]: defaultRoomSize,
  [BookingObjectType.PhoneRoom]: defaultRoomSize,
  [BookingObjectType.Parking]: defaultParkingSize,
};

export const regularBookingObjectTypeOptions: Option<string>[] = [
  BookingObjectType.Desk,
  BookingObjectType.MeetingRoom,
  BookingObjectType.FocusRoom,
  BookingObjectType.PhoneRoom,
].map(bot => ({ id: bot, value: labelsByBookingObjectType[bot] }));

export const parkingBookingObjectTypeOptions: Option<string>[] = [
  BookingObjectType.Parking,
].map(bot => ({ id: bot, value: labelsByBookingObjectType[bot] }));
